export default "__VITE_ASSET__YXwysdoo__"